var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_521)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 74.25C57.7965 74.25 74.25 57.7965 74.25 37.5C74.25 17.2035 57.7965 0.75 37.5 0.75C17.2035 0.75 0.75 17.2035 0.75 37.5C0.75 57.7965 17.2035 74.25 37.5 74.25Z",
    fill: "#384241"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_558_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 43,
    height: 43
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 16.5H16.5V58.5H58.5V16.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_558_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2163 28.3533C53.9766 27.9347 53.6257 27.5906 53.2024 27.3591L38.76 19.4529C38.374 19.2407 37.9406 19.1294 37.5 19.1294C37.0594 19.1294 36.626 19.2407 36.24 19.4529L21.8025 27.3574C21.3793 27.5889 21.0283 27.933 20.7886 28.3517C20.56 28.7479 20.4391 29.1969 20.4375 29.6543V45.3453C20.4385 45.8152 20.5658 46.2763 20.8059 46.6803C21.046 47.0844 21.3902 47.4165 21.8025 47.6421L36.24 55.545C36.6257 55.7582 37.0593 55.8699 37.5 55.8699C37.9407 55.8699 38.3743 55.7582 38.76 55.545L53.1975 47.6421C53.6098 47.4165 53.9539 47.0844 54.1941 46.6803C54.4342 46.2763 54.5615 45.8152 54.5625 45.3453V29.6543C54.5622 29.1979 54.4429 28.7495 54.2163 28.3533ZM36.1875 52.5296L30.9375 49.6552V41.4373C30.937 41.2023 30.8734 40.9717 30.7533 40.7697C30.6332 40.5677 30.4612 40.4016 30.255 40.2888L23.0625 36.3513V31.1013L36.1875 38.2873V52.5296ZM37.5 36.0036L24.4833 28.8767L30.1402 25.7808L36.8667 29.464C37.0599 29.5697 37.2765 29.6251 37.4967 29.6251C37.7169 29.6251 37.9336 29.5697 38.1267 29.464L44.8533 25.7808L50.5102 28.8767L37.5 36.0036ZM51.9375 36.348L44.745 40.2855C44.5388 40.3983 44.3668 40.5645 44.2467 40.7664C44.1266 40.9685 44.063 41.199 44.0625 41.434V49.6519L38.8125 52.5263V38.2774L51.9375 31.0915V36.348Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.3c93aef7ea2ff191cb2b31a8dfc2dfc3.svg";
export { ForwardRef as ReactComponent };